<div class="loading-fullscreen">
  <div class="loading">
    <div class="box">
      <div class="indicator"></div>
      <div class="text">Authorizing your session..</div>
    </div>
  </div>
</div>